import { z } from 'zod';

export const baseCriteriaItemSchema = z.object({
  discriminatorCode: z.string().nullish(),
  note: z.string().nullish(),
  link: z.union([z.literal(''), z.literal(null), z.string().trim().url()]),
  newFile: z.custom<File>().nullable(),
  file: z
    .object({
      title: z.string().nullable(),
    })
    .nullable(),
  criteriaType: z.enum([
    'FREE_ANSWER',
    'NUMBER',
    'BOOLEAN',
    'SELECT_ABSTRACT',
    'SELECT_ARTICLE',
    'SELECT_BOOK',
    'SELECT_CHAPTER',
    'SELECT_COURSE',
    'SELECT_COMMITTEE',
    'SELECT_PROJECT',
    'SELECT_PATENT',
    'SELECT_TRANSLATION',
    'SELECT_PROCEEDING',
  ]),
});

export const freeCriteriaItemSchema = baseCriteriaItemSchema.extend({
  activityDescription: z.string().min(3),
});

export const booleanCriteriaItemSchema = baseCriteriaItemSchema.extend({});

export const numberCriteriaItemSchema = baseCriteriaItemSchema.extend({
  number: z.coerce.number().min(0),
});

export const selectSchema = z.object({
  id: z.coerce.number(),
  title: z.string().nullish(),
});

export const courseCriteriaItemSchema = baseCriteriaItemSchema.extend({
  course: selectSchema,
});

export const abstractCriteriaItemSchema = baseCriteriaItemSchema.extend({
  abstractItem: selectSchema,
});

export const articleCriteriaItemSchema = baseCriteriaItemSchema.extend({
  article: selectSchema,
});

export const bookCriteriaItemSchema = baseCriteriaItemSchema.extend({
  book: selectSchema,
});

export const translationCriteriaItemSchema = baseCriteriaItemSchema.extend({
  translation: selectSchema,
});

export const proceedingCriteriaItemSchema = baseCriteriaItemSchema.extend({
  proceeding: selectSchema,
});

export const chapterCriteriaItemSchema = baseCriteriaItemSchema.extend({
  chapter: selectSchema,
});

export const committeeCriteriaItemSchema = baseCriteriaItemSchema.extend({
  committee: selectSchema,
});

export const projectCriteriaItemSchema = baseCriteriaItemSchema.extend({
  project: selectSchema,
});

export const patentCriteriaItemSchema = baseCriteriaItemSchema.extend({
  patent: selectSchema,
});

export type BaseCriteriaItemSchema = z.infer<typeof baseCriteriaItemSchema>;
